import { Navigate, useLocation } from 'react-router'

interface Props {
	to: string
}

const RedirectWithSearch = (props: Props) => {
	const { to } = props
	const { search } = useLocation()

	return <Navigate to={search ? `${to}${search}` : to} replace />
}

export default RedirectWithSearch
